import React from 'react';

import ActionsAddPasswordDocument from './ActionsAddPasswordDocument';

const ActionsAddPasswordExcel = (props) => (
  <ActionsAddPasswordDocument
    {...props}
    actionType="addpasswordexcel"
    allowReplaceExistingDocument
    defaultTargetPath={'C:\\output\\{filename}_protected.xlsx'}
    documentType="Excel"
    extension="xlsx"
    titleKey="workflow.add_password_excel_title"
    titleFallback="Add Password to Excel"
  />
);

export default React.memo(ActionsAddPasswordExcel);
